export enum ExtraType {
  damageWaiver = 'damageWaiver',
}
